import { useCallback } from 'react';
import { useLocalStorage } from 'react-use';

const useShowClearByOnDemandTooltip = () => {
  const [showClearByOnDemandTooltip, setShowClearByOnDemandTooltip] = useLocalStorage(
    'ondemand_show_clear_tooltip',
    true
  );
  return [
    showClearByOnDemandTooltip ?? true,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useCallback(() => setShowClearByOnDemandTooltip(false), []),
  ];
};

export default useShowClearByOnDemandTooltip;
